import { Component, OnInit, ChangeDetectorRef  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionnaireService } from '../services/questionnaire.service';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { IncomesArrayComponent } from '../incomes-array/incomes-array.component';
import { BorrowersArrayComponent } from '../borrowers-array/borrowers-array.component';
import { ValidateId } from '../id-validator';
import { ValidateDate } from '../date-validator';
import { map, startWith } from 'rxjs/operators';
import { data } from '../../israel-cities';
import { Observable } from 'rxjs';


import { AddBorrowerComponent } from '../add-borrower/add-borrower.component';
import { LineOtherIncomeComponent } from '../line-other-income/line-other-income.component';

import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import {NgbDateStruct, NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';
import { isNumber, toInteger, padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-borrowers-details',
    templateUrl: './borrowers-details.component.html',
    styleUrls: ['./borrowers-details.component.scss']
})
export class BorrowersDetailsComponent implements OnInit {
    private route$: Subscription;
    qID: any;
    selectedOption: any;
    prevQID: any;
    console = console;
    window = window;
    visibleQids;
    editQuestion;
    currentStep;
    userMoreDetails;
    borrowerDetails: FormGroup;
    submitted = false;
    borrowersFlag = false;
    errowAddBrrower = false;
    borrowers;
    options;
    isMobilePhone: boolean;
    typeCmbo: string[] = ["אין לי הכנסות נוספות", "דמי מזונות", "מלגה", "קצבת נכות", "הכנסה משכ''ד", "אחר"];
	DATACities: any = data;
	public citiesList;
	cityFilterListEmployee: Observable<any[]>;
	cityFilterListForIndependent: Observable<any[]>;
    cityFilterLists: Observable<any[]>[] = [];
    cityFilterListsForEmployee: Observable<any[]>[] = [];
    cityFilterListsForIndependent: Observable<any[]>[] = [];
    qFields = {
        1: [{ name: "areThereAdditionalBorrowers", validators: [] }],
        2: [{ name: "borrowersArray", type: "Date", validators: [] }],
        /* borrower 1 */
        "3-1": [{ name: "brwEmploymentStatus-1", validators: [] }],
        "4a-1": [{ name: "brwEmployersCompanyName-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
        "4b-1": [{ name: "brwIndependentCompanyName-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
        "5a-1": [
            { name: "brwEmployersCompanyField-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwEmployersProfession-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwEmployersCompanySeniority-1", validators: [Validators.required, Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")] },
            { name: "brwYeshuvAvodaForEmployee-1", validators: [Validators.required, this.isInCityList()]}

        ],
        "5b-1": [
            { name: "brwIndependentCompanyField-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwIndependentProfession-1", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwIndependentCompanySeniority-1", validators: [Validators.required , Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")]},
            { name: "brwYeshuvAvodaForIndependent-1", validators: [Validators.required, this.isInCityList()]}
        ],
        "6a-1": [{ name: "brwEmployersMonthlyIncome-1", validators: [Validators.required] }],
        "6b-1": [{ name: "brwIndependentYearlyIncome-1", validators: [Validators.required] }],
        "7a-1": [{ name: "brwAreThereOtherIncome-1", validators: [] }],
        "7b-1": [{ name: "brwOtherIncome-1", validators: [] }],

        /* borrower 2 */
        "3-2": [{ name: "brwEmploymentStatus-2", validators: [] }],
        "4a-2": [{ name: "brwEmployersCompanyName-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
        "4b-2": [{ name: "brwIndependentCompanyName-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
        "5a-2": [
            { name: "brwEmployersCompanyField-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwEmployersProfession-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwEmployersCompanySeniority-2", validators: [Validators.required , Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")]},
            { name: "brwYeshuvAvodaForEmployee-2", validators: [Validators.required, this.isInCityList()]}
        ],
        "5b-2": [
            { name: "brwIndependentCompanyField-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwIndependentProfession-2", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwIndependentCompanySeniority-2", validators: [Validators.required, Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")] },
            { name: "brwYeshuvAvodaForIndependent-2", validators: [Validators.required, this.isInCityList()]}
        ],
        "6a-2": [{ name: "brwEmployersMonthlyIncome-2", validators: [Validators.required] }],
        "6b-2": [{ name: "brwIndependentYearlyIncome-2", validators: [Validators.required] }],
        "7a-2": [{ name: "brwAreThereOtherIncome-2", validators: [] }],
        "7b-2": [{ name: "brwOtherIncome-2", validators: [] }],


        /* borrower 3 */
        "3-3": [{ name: "brwEmploymentStatus-3", validators: [] }],
        "4a-3": [{ name: "brwEmployersCompanyName-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
        "4b-3": [{ name: "brwIndependentCompanyName-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
        "5a-3": [
            { name: "brwEmployersCompanyField-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwEmployersProfession-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwEmployersCompanySeniority-3", validators: [Validators.required, Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")] },
            { name: "brwYeshuvAvodaForEmployee-3", validators: [Validators.required, this.isInCityList()]}
        ],
        "5b-3": [
            { name: "brwIndependentCompanyField-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwIndependentProfession-3", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] },
            { name: "brwIndependentCompanySeniority-3", validators: [Validators.required, Validators.pattern("^([0]\.[5-9]||[1-9]||[1-9]\.([1-9])||[1-6][0-9]\.([1-9])||[1-6][0-9]||[7][0])")] },
            { name: "brwYeshuvAvodaForIndependent-3", validators: [Validators.required, this.isInCityList()]}
        ],
        "6a-3": [{ name: "brwEmployersMonthlyIncome-3", validators: [Validators.required] }],
        "6b-3": [{ name: "brwIndependentYearlyIncome-3", validators: [Validators.required] }],
        "7a-3": [{ name: "brwAreThereOtherIncome-3", validators: [] }],
        "7b-3": [{ name: "brwOtherIncome-3", validators: [] }]

    };

    qArrFields = {
        2: [
            { name: "borrowerProximity", validators: [Validators.required] },
            { name: "borrowerFullName", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ \.]*$")] },
            { name: "borrowerIdNumber", validators: [Validators.required, ValidateId] },
            { name: "borrowerPhoneNumber", validators: [Validators.required, this.validatePhone(), Validators.pattern("^[0-9]*$")] },
            { name: "borrowerBirthDate", validators: [Validators.required, ValidateDate], type: "Date" },
            { name: "borrowerEmail", validators: [Validators.pattern("^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,5})$")] },
            { name: "borrowerId", validators: [] }
        ],
        '7b-1': [
            { name: "type", validators: [Validators.required] },
            { name: "amount", validators: [Validators.required, Validators.min(1)] },
            { name: "source", validators: [Validators.required] }
        ],
        '7b-2': [
            { name: "type", validators: [Validators.required] },
            { name: "amount", validators: [Validators.required, Validators.min(1)] },
            { name: "source", validators: [Validators.required] }
        ],
        '7b-3': [
            { name: "type", validators: [Validators.required] },
            { name: "amount", validators: [Validators.required, Validators.min(1)] },
            { name: "source", validators: [Validators.required] }
        ],
    };

    constructor(private route: ActivatedRoute,
        private questionnaireService: QuestionnaireService,
        private activeRoute: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
        this.currentStep = this.questionnaireService.getStep("borrowers-details");
        this.userMoreDetails = this.questionnaireService.getStep("user-more-details");
    }

    ngOnInit() {
		this.citiesList = this.DATACities.Cities;	

        this.borrowers = this.questionnaireService.getBorrowers();
        this.createForm();
        this.updateFormWithControls();

        this.route$ = this.activeRoute.params.subscribe(params => {
            this.prevQID = this.qID;
            this.qID = params['qid'];
            this.editQuestion = null;

			let quest1 = this.questionnaireService.getQuestion(this.userMoreDetails, "1");
			let q2 =  this.questionnaireService.getQuestion(this.currentStep, "2");
			let q1 =  this.questionnaireService.getQuestion(this.currentStep, "1");
			let respKirva = quest1.answer.fields.find(i => i.answerText === "מצב משפחתי");
			//let step4 = this.questionnaireService.getStepByID("4");

			if (this.qID === '2' && respKirva.answerValue === "נשוי") {
				q2.answer['answer-data'][0].fields[0].answerValue = "בן/בת זוג";
				q1.selectedAnswer = "YES";
				q2.answer['answer-data'][0].fields.required = true;
				this.borrowers = this.questionnaireService.getBorrowers();
				this.rebuildFormFor2();
				//this.updateFormWithControls();
			} else if(this.qID === '2' && respKirva.answerValue !== "נשוי") {
				q2.answer['answer-data'][0].fields[0].answerValue = "";
				q2.answer['answer-data'][0].fields.required = false;
				this.borrowers = this.questionnaireService.getBorrowers();
				this.rebuildFormFor2();
			}
            
            if (params.qid === "all") {
                this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
            } else {
                this.borrowers = this.questionnaireService.getBorrowers();
                this.updateFormWithControls();

                this.setValidators();
                this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
            }
        });

        this.options = [
            { label: 'BORROWERS_DETAILS.QUESTION3.A1', id: "employee", class: "employee" },
            { label: 'BORROWERS_DETAILS.QUESTION3.A2', id: "independent", class: "independent" },
            { label: 'BORROWERS_DETAILS.QUESTION3.A3', id: "unemployed", class: "unemployed" },
            { label: 'BORROWERS_DETAILS.QUESTION3.A4', id: "employeeAndIndependent", class: "employee-independent" }
        ];



        // this.cityFilterListEmployee = this.userMoreDetails.controls["brwYeshuvAvodaForEmployee-1"].valueChanges
		// .pipe(
		// 	startWith(''),
		// 	map((city: string) => city ? this.filterCity(city) : this.citiesList.slice())
		// );
		// this.cityFilterListForIndependent = this.userMoreDetails.controls["yeshuvAvodaForIndependent"].valueChanges
		// .pipe(
		// 	startWith(''),
		// 	map((city: string) => city ? this.filterCity(city) : this.citiesList.slice())
		// );
    }

    initCityFilters() {
        this.borrowerDetails.controls.borrowersArray.value.forEach((question, i) =>  {
          
            const control1 = this.borrowerDetails.controls[`brwYeshuvAvodaForEmployee-${i + 1}`];
        
            if(control1) {
                this.cityFilterListsForEmployee[i] = control1.valueChanges.pipe(
                startWith(''),
                map((city: string) => city ? this.filterCity(city) : this.citiesList.slice())
                );
            }

            const control2 = this.borrowerDetails.controls[`brwYeshuvAvodaForIndependent-${i + 1}`];
        
            if(control2) {
                this.cityFilterListsForIndependent[i] = control2.valueChanges.pipe(
                startWith(''),
                map((city: string) => city ? this.filterCity(city) : this.citiesList.slice())
                );
            }

        });
      }

    getCityFilterListForEmployee(index: number): Observable<any[]> {
        return this.cityFilterListsForEmployee[index];
    }

    getCityFilterListForIndependent(index: number): Observable<any[]> {
        return this.cityFilterListsForIndependent[index];
    }

	rebuildFormFor2() {
		this.borrowerDetails.setControl('borrowersArray',BorrowersArrayComponent.builBorrowers(this.questionnaireService.getQuestion(this.currentStep, "2").answer['answer-data']));
    }
    
    ngAfterViewChecked(): void {
        this.changeDetectorRef.detectChanges();
    }

    filterCity(name: string) {
		return this.citiesList.filter(item =>
			item.name.toLowerCase().indexOf(name.toLowerCase()) === 0);	
    }


	isInCityList() {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value.length>0) {
				let cityBingo = this.citiesList.filter(city =>city.name === control.value);
					if (cityBingo.length < 1) {
						return {isNotInCityList: true};
					}
					else return null;
			}
		}
	}

    validatePhone(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (this.isMobilePhone && control.value && control.value.length < 10) {//isMobilePhone not work
                return {
                    minlength: true
                };
            } else if (!this.isMobilePhone && control.value && control.value.length < 9) {//isMobilePhone not work
                return {
                    minlength: true
                };
            }
        };
    }

    createForm() {
        this.borrowerDetails = this.fb.group({ // <-- the parent FormGroup
            'areThereAdditionalBorrowers': this.questionnaireService.getQuestion(this.currentStep, "1").selectedAnswer,
            'borrowersArray': BorrowersArrayComponent.builBorrowers(this.questionnaireService.getQuestion(this.currentStep, "2").answer['answer-data'])
        });
    }

    setValidators() {
        this.questionnaireService.clearAllQuestionValidators(this.borrowerDetails.controls, this.qFields, this.qArrFields);
        this.questionnaireService.setCurrentQuestionValidators(this.qID, this.borrowerDetails.controls, this.qFields, "4", this.qArrFields, false);
		this.submitted = false;
		this.errowAddBrrower = false;
        if(this.qID === '3-1'){
            this.initCityFilters();
        }
    }

    nextClick(qID, answers) {
        if (answers) {
            this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
            this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
            this.borrowersFlag = true;
        }
    }

    onSubmit({ value, valid }: { value: any, valid: boolean }) {
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit(): valid=", valid, ", value=", value);
		value = this.borrowerDetails.getRawValue();
        if (value.borrowersArray.length === 0 && this.borrowersFlag) {
			this.errowAddBrrower = true;
		}
        else{
            this.submitted = true;
            if (valid) {
                let q;
                let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

                q = this.qFields[submitQID];
                q.forEach(element => {
                    if (element.type) {
                        if (value[element.name].length) {
                            for (let index = 0; index < value[element.name].length; index++) {
                                value[element.name][index].borrowerBirthDate = this.questionnaireService.customParse(value[element.name][index].borrowerBirthDate);
                            }
                        } else {
                            value[element.name] = this.questionnaireService.customParse(value[element.name]);
                        }
                    }
                });

                let values = q.map(r => {
                    return value[r.name];
                });

                if (!Array.isArray(values) || (Array.isArray(values) && values && values[0])) {
                    this.questionnaireService.sendGA(this.currentStep, this.qID, values);
                    this.nextClick(submitQID, values);
                }
            } else {
                window["logInvalidControls"](this.borrowerDetails);
			}
        }
    }

	editQuestionChange(qid) {
		this.qID = qid;
		this.setValidators();
	}

	// borrowers loop
	getqID(qid, index) {
		index = index + 1;
		let str = '';
		str = qid + '-' + index;
		return str;
	}

		//add borrowers form controls
	updateFormWithControls() {
		let getQuestion = this.questionnaireService.getQuestion;

		for (let i = 0; i < this.borrowers.length; i++) {
			this.borrowerDetails.addControl('brwEmploymentStatus-' + (i + 1), new FormControl(getQuestion(this.currentStep, "3-" + (i + 1)).selectedAnswer[0]));
			
			this.borrowerDetails.addControl('brwEmployersCompanyName-' + (i + 1), new FormControl(getQuestion(this.currentStep, "4a-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwIndependentCompanyName-' + (i + 1), new FormControl(getQuestion(this.currentStep, "4b-" + (i + 1)).answer.fields[0].answerValue));

			this.borrowerDetails.addControl('brwEmployersCompanyField-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5a-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwEmployersProfession-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5a-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwEmployersCompanySeniority-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5a-" + (i + 1)).answer.fields[2].answerValue));
			this.borrowerDetails.addControl('brwYeshuvAvodaForEmployee-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5a-" + (i + 1)).answer.fields[3].answerValue));

            this.borrowerDetails.addControl('brwIndependentCompanyField-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5b-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwIndependentProfession-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5b-" + (i + 1)).answer.fields[1].answerValue));
			this.borrowerDetails.addControl('brwIndependentCompanySeniority-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5b-" + (i + 1)).answer.fields[2].answerValue));
            this.borrowerDetails.addControl('brwYeshuvAvodaForIndependent-' + (i + 1), new FormControl(getQuestion(this.currentStep, "5b-" + (i + 1)).answer.fields[3].answerValue));

			this.borrowerDetails.addControl('brwEmployersMonthlyIncome-' + (i + 1), new FormControl(getQuestion(this.currentStep, "6a-" + (i + 1)).answer.fields[0].answerValue));
			this.borrowerDetails.addControl('brwIndependentYearlyIncome-' + (i + 1), new FormControl(getQuestion(this.currentStep, "6b-" + (i + 1)).answer.fields[0].answerValue));

			this.borrowerDetails.addControl('brwAreThereOtherIncome-' + (i + 1), new FormControl(getQuestion(this.currentStep, "7a-" + (i + 1)).selectedAnswer[0]));
			this.borrowerDetails.addControl('brwOtherIncome-' + (i + 1), IncomesArrayComponent.buildIncomes(getQuestion(this.currentStep, "7b-" + (i + 1)).answer.fieldsArray));
		}
	}

	rebuildFormForQ2() {
		this.borrowerDetails.setControl('borrowersArray',BorrowersArrayComponent.builBorrowers(this.questionnaireService.getQuestion(this.currentStep, "2").answer['answer-data']));
	}

}



// WEBPACK FOOTER //
// ./src/app/borrowers-details/borrowers-details.component.ts